import React, { useEffect, useState } from 'react'
import "./couponmgmt.css";

import { Modal, Dropdown } from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Couponmgmt = () => {
  const [modalAddCoupon, setModalAddCoupon] = useState(false);
  const [coupanName, setCoupanName] = useState("")
  const [coupanDescription, setCoupanDescription] = useState("")
  const [coupanCode, setCoupanCode] = useState("")
  const [coupanMinCartValue, setCoupanMinCartValue] = useState("")
  const [coupanStatus, setCoupanStatus] = useState("")
  const [coupanStartDate, setCoupanStartDate] = useState("")
  const [coupanEndDate, setCoupanEndDate] = useState("")
  const [coupantype, setCoupantype] = useState("")
  const [coupanDiscount, setCoupanDiscount] = useState("")
  const [coupanGift, setCoupanGift] = useState("")
  const [coupan, setCoupan] = useState([]);
  const [originalCoupan, setOriginalCoupan] = useState([]); 
  const [noOfUser, setNoOfUser] = useState("")
  const [coupanid, setCoupanid] = useState("")
  const [searchvalue, setsearchvalue] = useState("")
  const getCoupan = async () => {
    try {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotGetCoupan`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          setCoupan(response.data)
          setOriginalCoupan(response.data) 
        } else {
          toast.error(response.message)
        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }
  }
  const createCoupan = async () => {
    if (coupanName === "") {
      toast.error("Please Enter Coupan Name")
    } else if(coupanDescription === ""){
      toast.error("Please Enter Coupan Description")
    }else if (coupanCode === "") {
      toast.error("Please Enter Coupan Code")
    } else if (coupanMinCartValue === "") {
      toast.error("Please Enter Minimum Cart Value")
    } else if (coupanStartDate === "") {
      toast.error("Please Enter Start Date")
    } else if (coupanEndDate === "") {
      toast.error("Please Enter End Date")
    } else if (coupantype === "") {
      toast.error("Please Enter Discount Type")
    } else if (coupanDiscount === "") {
      toast.error("Please Enter Discount")
    } else if (coupanStatus === "") {
      toast.error("Please Select Status")
    } else if (coupanGift === "") {
      toast.error("Please Select Coupon Type")
    } else if (coupanGift === "first" && noOfUser === "") {

      toast.error("Please Enter No of User")


    } else if (coupanGift === "gift" && noOfUser === "") {

      toast.error("Please Enter No of User")


    } else {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotCreateCoupan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          "coupon_name": coupanName,
          "coupon_description": coupanDescription,
          "coupon_code": coupanCode,
          "min_cart_value": coupanMinCartValue,
          "start_date": coupanStartDate,
          "end_date": coupanEndDate,
          "discount_type": coupantype,
          "discount": coupanDiscount,
          "noOfUsers": noOfUser !== "" ? noOfUser : "",
          "type": coupantype,
          "status": coupanStatus,
          "gift": coupanGift
        })
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          toast.success(response.message)
          getCoupan()
          setModalAddCoupon(false);
          setCoupanCode("");
          setCoupanDiscount("");
          setCoupanEndDate("");
          setCoupanGift("");
          setCoupanMinCartValue("");
          setCoupanName("");
          setCoupanDescription("");
          setNoOfUser("")
          setCoupanStartDate("");
          setCoupanStatus("");
          setCoupantype("");
        } else {
          toast.error(response.message)
        }
      })


    }
  }

  useEffect(() => {
    getCoupan()
  }, [])

  const UpdateCoupan = async (id) => {
    const filteredData = coupan.filter((item) => {
      return item.coupanid === id
    })
    setCoupanName(filteredData[0].coupon_name)
    setCoupanCode(filteredData[0].coupon_code)
    setCoupanDescription(filteredData[0].coupon_description)
    setCoupanMinCartValue(filteredData[0].min_cart_value)
    setCoupanStatus(filteredData[0].status)
    setCoupanStartDate(filteredData[0].start_date)
    setCoupanEndDate(filteredData[0].end_date)
    setCoupantype(filteredData[0].discount_type)
    setNoOfUser(filteredData[0].noOfUsers)
    setCoupanDiscount(filteredData[0].discount)
    setCoupanGift(filteredData[0].gift)
    setModalAddCoupon(true)
    setCoupanid(id)
  }
  const updateCoupan = async () => {
    try {
      if (coupanName === "") {
        toast.error("Please Enter Coupan Name")
      }  else if(coupanDescription === ""){
        toast.error("Please Enter Coupan Description")
      }else if (coupanCode === "") {
        toast.error("Please Enter Coupan Code")
      } else if (coupanMinCartValue === "") {
        toast.error("Please Enter Minimum Cart Value")
      } else if (coupanStartDate === "") {
        toast.error("Please Enter Start Date")
      } else if (coupanEndDate === "") {
        toast.error("Please Enter End Date")
      } else if (coupantype === "") {
        toast.error("Please Enter Discount Type")
      } else if (coupanDiscount === "") {
        toast.error("Please Enter Discount")
      } else if (coupanStatus === "") {
        toast.error("Please Select Status")
      } else if (coupanGift === "") {
        toast.error("Please Select Coupon Type")
      } else if (coupanGift === "first" && noOfUser === "") {

        toast.error("Please Enter No of User")


      } else if (coupanGift === "gift" && noOfUser === "") {

        toast.error("Please Enter No of User")


      } else {
        fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotUpdateCoupan`, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${window.localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            "coupanid": coupanid,
            "coupon_name": coupanName,
            "coupon_description": coupanDescription,
            "coupon_code": coupanCode,
            "min_cart_value": coupanMinCartValue,
            "start_date": coupanStartDate,
            "end_date": coupanEndDate,
            "discount_type": coupantype,
            "noOfUsers": noOfUser !== "" ? noOfUser : "",
            "discount": coupanDiscount,
            "type": coupantype,
            "status": coupanStatus,
            "gift": coupanGift
          })
        }).then((res) => res.json()).then((response) => {
          if (response.status === 200) {
            toast.success(response.message)
            getCoupan()
            setModalAddCoupon(false);
            setCoupanCode("");
            setCoupanDiscount("");
            setCoupanEndDate("");
            setCoupanGift("");
            setCoupanMinCartValue("");
            setCoupanName("");
            setCoupanDescription("");
            setNoOfUser("")
            setCoupanStartDate("");
            setCoupanStatus("");
            setCoupantype("");
          } else {
            toast.error(response.message)
          }
        })
      }





    } catch (error) {
      console.error('API Error:', error);
    }
  }
  const deleteCoupan = async (id) => {
    try {
      fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotDeleteCoupan`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          "coupanid": id
        })
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          toast.success(response.message)
          getCoupan()
        } else {
          toast.error(response.message)
        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }
  }

  const search = async () => {
    if (searchvalue.length > 0) {
      const filteredData = originalCoupan.filter((item) => {
        return item.coupon_name.toLowerCase().includes(searchvalue.toLowerCase()) || item.coupon_code.toLowerCase().includes(searchvalue.toLowerCase())
      })
      setCoupan(filteredData)
      setCurrentPage(1)
    } else {
      setCoupan(originalCoupan)
      setCurrentPage(1)
    }
  }

  const sort = async (value) => {
    let dataToFilter = searchvalue.length > 0 ? 
      originalCoupan.filter((item) => {
        return item.coupon_name.toLowerCase().includes(searchvalue.toLowerCase()) || 
               item.coupon_code.toLowerCase().includes(searchvalue.toLowerCase())
      }) : 
      [...originalCoupan];
      
    if (value === "Active") {
      const filteredData = dataToFilter.filter((item) => {
        return item.status === "Active"
      })
      setCoupan(filteredData)
    } else if(value === "expired"){
      const filteredData = dataToFilter.filter((item) => {
        return item.status === "expired"
      })
      setCoupan(filteredData)
    } else if(value === "Inactive") {
      const filteredData = dataToFilter.filter((item) => {
        return item.status === "Inactive"
      })
      setCoupan(filteredData)
    } else {
      if (searchvalue.length > 0) {
        search();
      } else {
        setCoupan(originalCoupan);
      }
    }
    setCurrentPage(1)
  }
  
  const refreshData = async () => {
    setsearchvalue("");
    await getCoupan();
    setCurrentPage(1);
    toast.success("Data refreshed successfully");
  }
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); 

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = coupan.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <>
      <section className="dashbg-color">

        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="admin-filters">

              <div className="search-bar">
                <div className="search-container">
                  <form action="">
                    <input type="text" placeholder="Search by- Coupan Name, Coupan Code" name="search" value={searchvalue} onChange={(e) => {
                      setsearchvalue(e.target.value)
                      if (e.target.value === '') {
                        setCoupan(originalCoupan)
                        setCurrentPage(1)
                      }
                    }} />
                    <button type="button" onClick={() => {
                      search()
                    }}><i className="fa fa-search"></i></button>
                  </form>
                </div>
              </div>

              <div className="filters d-flex">
                <Dropdown className="d-inline mx-2">
                  <Dropdown.Toggle id="dropdown-autoclose-true" className="btn filter-pop m-1 " > Sort by <i className="fa fa-sort"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => {
                      sort("Active")
                    }}>Active</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      sort("Inactive")
                    }}>Inactive</Dropdown.Item>
                     <Dropdown.Item onClick={() => {
                      sort("expired")
                    }}>Expired</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      sort("All")
                    }}>All</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <button className="btn filter-pop m-1" onClick={() => {
                  setModalAddCoupon(true);
                  setCoupanid("")
                }}>Add Coupon <i className="fa fa-plus"></i></button>
                
                <button className="btn filter-pop ml-2" style={{ backgroundColor: "white", color: "#4CAF50", borderColor:"#4CAF50" }} onClick={refreshData}>
                   <i className="fas fa-sync-alt"></i>
                </button>
              </div>

            </div>
          </div>
        </div>

        <div className="row justify-content-center">
      <div className="col-lg-12 table-bg">
        <div style={{ backgroundColor: "white" }}>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">S.No.</th>
                  <th scope="col">Coupon Name</th>
                  <th scope="col">Code</th>
                  <th scope="col">Discount</th>
                  <th scope="col">Coupon Type</th>
                  <th scope="col">No Of User</th>
                  <th scope="col">Status</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">End Date</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 &&
                  currentItems.map((item, index) => {
                    return (
                      <tr key={index}>
                        <th scope="row">{index + indexOfFirstItem + 1}</th>
                        <td>{item.coupon_name}</td>
                        <td>{item.coupon_code}</td>
                        <td>
                          {item.discount_type === "Rs."
                            ? item.discount_type
                            : ""}
                          {item.discount}
                          {item.discount_type === "%" ? item.discount_type : ""}
                        </td>
                        <td>
                          {item.gift === "first"
                            ? "First User"
                            : item.gift === "gift"
                            ? "Gift User"
                            : "All User"}
                        </td>
                        <td>{item.NoOfTimesCoupan || 0}</td>
                        <td>
                          {item.status === "Active" ? (
                            <span className="text-success">{item.status?.toUpperCase()}</span>
                          ) : (
                            <span className="text-danger">{item.status?.toUpperCase()}</span>
                          )}
                        </td>
                        <td>{item.start_date}</td>
                        <td>{item.end_date}</td>
                        <td>
                          <i
                            className="fa fa-edit text-warning"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              UpdateCoupan(item.coupanid);
                            }}
                          ></i>
                          &nbsp;&nbsp;
                          <i
                            className="fa fa-trash text-danger"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              deleteCoupan(item.coupanid);
                            }}
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
                {currentItems.length === 0 && (
                  <tr>
                    <td colSpan={10} className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {currentItems.length>0?<div className="row">
            <div className="col-lg-12 text-center" style={{ position: "relative" }}>
              <div className="pagination pagi">
              {currentPage === 1?"":<a href="javascript:void(0)" onClick={prevPage} disabled={currentPage === 1}>&laquo;</a>}
             
                {Array.from({ length: Math.ceil(coupan.length / itemsPerPage) }).map((_, index) => (
                  <a href="javascript:void(0)" key={index}
                  onClick={() => goToPage(index + 1)}
                  className={currentPage === index + 1 ? "active" : ""}>{index + 1}</a>
                ))}
                {currentPage === Math.ceil(coupan.length / itemsPerPage)?"": <a href="javascript:void(0)" onClick={nextPage}
                      disabled={currentPage === Math.ceil(coupan.length / itemsPerPage)}>&raquo;</a>}
              </div>
              <div className="table-no-count">
                Showing {Math.min(indexOfLastItem, coupan.length)} of {coupan.length} results
              </div>
            </div>
          </div>:""}
        </div>
      </div>
    </div>
        <Modal
          show={modalAddCoupon}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ padding: "0px" }}>
            <div className="topbox p-1">
              <div className=" col-lg-12 p-2 d-flex justify-content-between">
                <div className="col-sm-8" style={{ paddingRight: "2rem" }}>
                  <h3>{coupanid !== "" ? "Update" : "Add"} Coupon</h3>
                </div>
                <div className="col-sm-4">
                  <button className="btn filter-pop" onClick={() => {
                    setModalAddCoupon(false);
                    setCoupanCode("");
                    setCoupanDiscount("");
                    setCoupanEndDate("");
                    setCoupanGift("");
                    setNoOfUser("")
                    setCoupanMinCartValue("");
                    setCoupanName("");
                    setCoupanStartDate("");
                    setCoupanStatus("");
                    setCoupantype("");
                  }}><i className="fa fa-xmark"></i></button>
                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <form className="coupon-dt p-4">
              <div className="form-group input-box">
                <label for="inputAddress" className="details">Coupon Name:</label>
                <input type="text" className="form-control" id="inputAddress" placeholder="Diwali Sale" value={coupanName} onChange={(e) => {
                  setCoupanName(e.target.value)
                }} />
              </div>
              <div className="form-group input-box">
                <label for="inputAddress" className="details">Coupon Description:</label>
                <input type="text" className="form-control" id="inputAddress2" placeholder="Description" value={coupanDescription} onChange={(e) => {
                  setCoupanDescription(e.target.value)
                }} />
              </div>
              <div className="row">
                <div className="col input-box">
                  <label for="inputAddress" className="details">Coupon Code:</label>
                  <input type="text" className="form-control" placeholder="Diwali123" value={coupanCode} onChange={(e) => {
                    setCoupanCode(e.target.value)
                  }} />
                </div>
                <div className="col input-box">
                  <label for="inputAddress" className="details">Minimum Cart Value:</label>
                  <input type="number" className="form-control" placeholder="100" value={coupanMinCartValue} onChange={(e) => {
                    setCoupanMinCartValue(e.target.value)
                  }} />
                </div>
              </div>
              <div className="row">
                <div className="col input-box">
                  <label for="inputAddress" className="details">Start Date:</label>
                  <input type="date" className="form-control" placeholder="" value={coupanStartDate} onChange={(e) => {
                    setCoupanStartDate(e.target.value)
                  }} />
                </div>
                <div className="col input-box">
                  <label for="inputAddress" className="details">End Date:</label>
                  <input type="date" className="form-control" placeholder="dd/mm/yyyy" value={coupanEndDate} onChange={(e) => {
                    setCoupanEndDate(e.target.value)
                  }} />
                </div>
              </div>
              <div className="row">

                <div className="col Discount">
                  <div className='row'>
                    <label for="inputAddress" className="details">Discount:</label>
                    <div className="col-md-4 input-box">

                      <select className="p-2 m-1 border:1px solid #19289F form-control" value={coupantype} onChange={(e) => {
                        setCoupantype(e.target.value)
                      }}>
                        <option value={""}>Discount</option>
                        <option value={"%"}>%</option>
                        <option value={"Rs."}>Rs.</option>
                      </select>
                    </div>
                    <div className="col-md-8 input-box">

                      <input type="number" className="form-control" placeholder="100" style={{ marginTop: "4px" }} value={coupanDiscount} onChange={(e) => [
                        setCoupanDiscount(e.target.value)
                      ]} />
                    </div>
                  </div>
                </div>
                <div className="col Status">
                  <label for="inputAddress" className="details">Status:</label>
                  <select className="p-2 m-1 border:1px solid #19289F form-control" value={coupanStatus} onChange={(e) => {
                    setCoupanStatus(e.target.value)
                  }}>
                    <option value={""}>Status</option>
                    <option value={"Active"}>Active</option>
                    <option value={"Inactive"}>Inactive</option>
                    <option value={"expired"}>Expired</option>
                  </select>
                </div>

              </div>

              <div className='row'>
                <div className='col'>
                  <div className="col input-box">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" style={{ fontSize: "18px" }} checked={coupanGift == "gift"} onChange={() => {

                      setCoupanGift("gift")

                    }} />
                    <label className="form-check-label" for="exampleCheck1" style={{ paddingTop: "2px" }}>One time use only (Gift)</label>

                  </div>

                  {coupanGift == "gift" ? <div className='row'>
                    <div className="col-md-6 input-box">
                      <input type="number" className="form-control" placeholder="1" id="exampleCheckuser" value={noOfUser} onChange={(e) => {

                        setNoOfUser(e.target.value)

                      }} />


                    </div>
                  </div> : ""}
                  <div className='row'>
                    <div className="col input-box">
                      <input type="checkbox" className="form-check-input" id="exampleCheck1" style={{ fontSize: "18px" }} checked={coupanGift == "first"} onChange={() => {

                        setCoupanGift("first")

                      }} />
                      <label className="form-check-label" for="exampleCheck1" style={{ paddingTop: "2px" }}> First User</label>
                    </div>
                  </div>
                  {coupanGift == "first" ? <div className='row'>
                    <div className="col-md-6 input-box">
                      <input type="number" className="form-control" placeholder="1" id="exampleCheckuser" value={noOfUser} onChange={(e) => {

                        setNoOfUser(e.target.value)

                      }} />


                    </div>
                  </div> : ""}
                  <div className='row'>
                    <div className="col input-box">
                      <input type="checkbox" className="form-check-input" id="exampleCheck1" style={{ fontSize: "18px" }} checked={coupanGift == "All"} onChange={() => {

                        setCoupanGift("All")

                      }} />
                      <label className="form-check-label" for="exampleCheck1" style={{ paddingTop: "2px" }}> All User</label>
                    </div>
                  </div>
                </div>
                <div className='col Status' style={{
                  marginLeft:"30px"
                }}>
                  <label for="inputAddress" className="details">Specific Product:</label>
                  <select className=" m-1 border:1px solid #19289F form-control">
                    <option value={""}>Select Specific Product</option>
                    <option value="helix">Helix</option>
                    <option value="knoxx">Knoxx</option>
                    <option value="prizma">Prizma</option>
                    <option value="stella">Stella</option>
                    <option value="knoxx_quad">Knoxx Quad</option>
                    <option value="Stella_quad">Stella Quad</option>
                  </select>


                </div>
              </div>
              {/* <div className='row'>
                <div className="col input-box">
                  <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                  <label className="form-check-label" for="exampleCheck1"> No. of user</label>
                </div>
              </div> */}
            </form>
            <div className="Buttton d-flex mb-3 align-content-end justify-content-end p-3">
              <button className="btn1 m-1" onClick={() => {
                setModalAddCoupon(false);
                setCoupanCode("");
                setCoupanDiscount("");
                setCoupanEndDate("");
                setCoupanGift("");
                setCoupanMinCartValue("");
                setCoupanName("");
                setCoupanStartDate("");
                setCoupanStatus("");
                setCoupantype("");

              }}>Cancel</button>
              <button className="btn2 m-1" onClick={() => {
                coupanid !== "" ? updateCoupan() : createCoupan()
              }}>{coupanid !== "" ? "Update" : "Apply"}</button>
            </div>
          </Modal.Body>
        </Modal>

      </section >
    </>
  )
}
export default Couponmgmt;
